import React, { PureComponent, Children, cloneElement } from 'react';
import { isTab, isTabList, isTabPanel } from './helpers.js';

class TabbedView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: this.props.selectedIndex,
    };
    this.handleTabSelect = this.handleTabSelect.bind(this);
  }

  static defaultProps = {
    selectedIndex: 0,
    onSelect: () => {},
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.selectedIndex !== this.state.selectedIndex) {
      this.setState({ selectedIndex: nextProps.selectedIndex });
    }
  }

  handleTabSelect(tabIndex) {
    if (this.state.selectedIndex === tabIndex) return;
    this.setState({ selectedIndex: tabIndex }, () => {
      this.props.onSelect(tabIndex);
    });
  }

  handleTabKeyDown({ key, keyCode }) {
    const currentIndex = this.state.selectedIndex;

    if (key === 'ArrowRight') {
      const nextIndex = currentIndex + 1;
      const newIndex =
        nextIndex >= Object.keys(this.tabRefList).length ? 0 : nextIndex;

      this.tabRefList[newIndex].current.focus();
      this.handleTabSelect(newIndex);
    } else if (key === 'ArrowLeft') {
      const nextIndex = currentIndex - 1;
      const newIndex =
        nextIndex < 0 ? Object.keys(this.tabRefList).length - 1 : nextIndex;

      this.tabRefList[newIndex].current.focus();
      this.handleTabSelect(newIndex);
    }
  }

  handleTabUnmount = tabIndex => {
    if (tabIndex === this.state.selectedIndex) {
      // switch to the first tab
      this.handleTabSelect(0);
    }
  };

  renderChildren() {
    let index = 0;
    const { children } = this.props;
    const { selectedIndex } = this.state;
    this.tabRefList = {};

    return Children.map(children, child => {
      let result = child;
      if (isTabList(child)) {
        let tabIndex = 0;
        result = cloneElement(child, {
          children: Children.map(child.props.children, tab => {
            if (!isTab(tab)) return tab;
            const selfIndex = tabIndex;
            const ref = React.createRef();
            this.tabRefList[tabIndex] = ref;
            const props = {
              index: selfIndex,
              onClick: () => this.handleTabSelect(selfIndex),
              onKeyDown: e => this.handleTabKeyDown(e),
              onUnmount: this.handleTabUnmount,
              selected: selectedIndex === selfIndex,
              tabRef: ref,
            };
            tabIndex++; // eslint-disable-line
            return cloneElement(tab, props);
          }),
        });
      } else if (isTabPanel(child)) {
        const selected = index === selectedIndex;
        result = selected ? cloneElement(child, { selected }) : null;
        index++; // eslint-disable-line
      }
      return result;
    });
  }

  render() {
    return <div className="TabbedView">{this.renderChildren()}</div>;
  }
}

export default TabbedView;
